// retrigger variant selection
// when user lands on page
// so checkout button is 
// available immediately

(() => {
  if (!document.body.classList.contains('template-product')) return;
  const MAX_RETRIES = 10;
  const INTERVAL_MS = 300;
  let attempts = 0;

  const tryTriggerSizeSelection = () => {
    const checkedRadio = document.querySelector('input[name="globo-option-0"]:checked');
    if (checkedRadio) {
      checkedRadio.dispatchEvent(new Event('change', { bubbles: true }));
    } else if (attempts < MAX_RETRIES) {
      attempts++;
      setTimeout(tryTriggerSizeSelection, INTERVAL_MS);
    }
  };

  tryTriggerSizeSelection();
})();

(() => {
  const btn = document.querySelector('.hc-accessibility-button');
  if (btn) {
    btn.setAttribute('data-acsb-custom-trigger', 'true');
  }
})();